import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import swal from 'sweetalert';

import SvgIcon from 'react-icons-kit';
import {arrowUp} from 'react-icons-kit/icomoon/arrowUp'
import {arrowDown} from 'react-icons-kit/icomoon/arrowDown'
import {notification} from 'react-icons-kit/icomoon/notification'

import ModalStatus from './modalStatus';
import Help from '../../generics/help';
/*
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';

import {chevronDown} from 'react-icons-kit/fa/chevronDown';*/

var Config = require('../../../config')

class UnitsTraceability extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		//this.searchComponent = this.searchComponent.bind(this);
		//this.json2html = this.json2html.bind(this);

		this.state = {
			unit_number:"",
			unit_number_found:"",
			traceability:[],

			donation_date:"",
			bag_type:"",
			convoke_place:"",
			donation_type:"",
			group_rh:"",
			donor:"",
			status_level:false,
			show_columns_pools:false,
			units_pool:"",
			type:""
		}
	}

	componentWillMount(){

		if(!this.props.hiddeToReport){
			//this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
	    	
    		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
				form.elements[index + 1].focus();
				
			this.onSearch();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
	    	
		}
  	}

  	handleChange(e){
		this.setState({[e.target.name]: e.target.value});

		if(e.target.name === 'unit_type') 
			document.getElementById('unit_type').classList.remove('error'); 
	}

	validateSearch(){
		var valid = true;

		if(this.state.unit_number === ""){
			document.getElementById('unit_number').classList.add('error');
			valid = false;
		}else{
			document.getElementById('unit_number').classList.remove('error');
		}


		return valid;
	}

	onSearch(){
		if(this.validateSearch()){
			this.props.waiting.handleShow('Cargando...');
			this.setState({
				traceability:[],
				donation_date:"",
				bag_type:"",
				convoke_place:"",
				donation_type:"",
				group_rh:"",
				donor:"",
			});
			
			fetch(Config.default.apiGateway.URL+'units/simple_traceability?unit_number='+this.state.unit_number+
				'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'),{				
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(msg){
						swal("Error", msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					if(response.res !== null){
						this.setState({status_level:response.start_level_2});
						if(response.res.component !== null){
							if(response.res.unit_type === 'POOL' || response.res.unit_type === 'RECONSTITUTION'){
								this.setState({show_columns_pools:true, units_pool:response.res.units, type:response.res.unit_type});
							}else{
								this.setState({show_columns_pools:false, units_pool:"", type:""});
							}

							this.setState({
								traceability:[...this.state.traceability, {
									parent:null,
									children:response.res.id,
									component:response.res.component,
									component_number:response.res.component_number,
									volume:response.res.volume,
									ubication:response.res.ubication,
									status:response.res.status,
									process_date:response.res.process_date,
									process_hour:response.res.process_hour,
									show:response.res.children.length > 0 ? false : true,
									icon:false,
									caducidad:response.res.caducidad,
									hide_status:response.res.children.length > 0 ? false : true
								}]
							})
							console.log(this.state.traceability)
							this.setState({
								//traceability: response.res
								unit_number_found:response.res.unit_number,
								donation_date:response.res.donation_date,
								bag_type:response.res.blood_bag,
								convoke_place:response.res.convoke_place,
								donation_type:response.res.donation_type,
								group_rh:response.res.group_rh,
								donor:response.res.donor_name
							});

							this.updateTable(response.res.children, response.res.id, 28);

						}else{
							this.setState({
								//traceability: response.res
								unit_number_found:response.res.children[0].unit_number,
								donation_date:response.res.children[0].donation_date,
								bag_type:response.res.children[0].blood_bag,
								convoke_place:response.res.children[0].convoke_place,
								donation_type:response.res.children[0].donation_type,
								group_rh:response.res.children[0].group_rh,
								donor:response.res.children[0].donor_name
							});

							this.updateTable(response.res.children, null, 28);
						}
						
						
					}
						
					
					
				}
			})
			
		}else{
			swal("Error", "Campos requeridos", 'error');
		}

	}

	updateTable(json, parent, padd){

		json.map((js, i)=>{
			if(js.children.length > 0){
				this.setState({
					traceability:[...this.state.traceability, {
						parent:parent,
						children:js.id,
						component:js.component,
						component_number:js.component_number,
						volume:js.volume,
						ubication:js.ubication,
						status:js.status,
						process_date:js.process_date,
						process_hour:js.process_hour,
						show:false,
						icon:false,
						padding:padd+'px',
						caducidad:js.caducidad,
						hide_status:false,
					}]
				})
				
				this.updateTable(js.children, js.id, padd+20);
			}else{
				this.setState({
					traceability:[...this.state.traceability, {
						parent:parent,
						children:null,
						component:js.component,
						component_number:js.component_number,
						volume:js.volume,
						ubication:js.ubication,
						status:js.status,
						process_date:js.process_date,
						process_hour:js.process_hour,
						show:true,
						icon:true,
						padding:padd+'px',
						caducidad:js.caducidad,
						hide_status:true
					}]
				})
			}
		})
	}

	/*
	handleChangePanel = panel => (event, expanded) => {
        this.setState({
          expanded: expanded ? panel : false,
        });
    };

    json2html(json) { 
	   return json.map((js, i)=>{
	    	return (
	    		<div>
	    			<ExpansionPanel  onChange={this.handleChangePanel(i)} >
	    				<ExpansionPanelSummary expandIcon={<SvgIcon icon={chevronDown}/>} >
	    					<h4>
	    						{(js.info.data !== null ? moment(js.info.data.transaction.timestamp).format('DD/MM/YYYY H:mm') : "") +' '}
	    						{js.info.number +'\t'} 
	    						{js.info.component +' '}
			            		{js.info.process +' '}
			            		{(js.info.data !==null?js.info.data.user:"") +' '} 
			            		{(js.info.data !==null?js.info.data.transaction.ip_address:"")}
	    					</h4>
	    				</ExpansionPanelSummary>
	    				{js.childs.length > 0 ?
	    					<div className="col-xs-12">
	    						{this.json2html(js.childs)}
	    					</div>
	    				: <div className="col-xs-12">
	    					<Table>
	    						<thead>
	    							<tr>
	    								<th>Fecha - Hora</th>
										<th>Acción</th>
										<th>Incidencia</th>
										<th>Usuario</th>
										<th>IP</th>
	    							</tr>
	    						</thead>
	    						<tbody>
	    							{js.info.donation_traceability.map((don, j)=>{
	    								return <tr key={i}>
	    									<td>{don.data !== null ? moment(don.data.transaction.timestamp).format('DD/MM/YYYY H:mm') : null }</td>
	    									<td>{don.action !== null ? don.action : ""}
											</td>
											<td>{don.incident !== null ? don.incident : ""}</td>
											<td>{don.data !== null ? don.data.user : null}</td>
											<td>{don.data !== null ? don.data.transaction.ip_address : null}</td>
	    								</tr>
	    							})}
	    						</tbody>
	    					</Table>
	    				</div>}
	    			</ExpansionPanel>
	    		</div>
	    	)
	    	
	    })

	} */

	showParent(e, id){
		e.preventDefault();
		this.state.traceability.map((t, i)=>{
			
			if(id === this.state.traceability[0].children){
				this.state.traceability[0].icon = true;
				t.show = true;
				t.icon = false;
			}

			if(id === t.children || t.parent === id){
				if(t.children === id){
					t.show = true;
					t.icon = true;
				}

				if(t.parent === id){
					t.icon = false;
					t.show = true;
				}
			}
		})

	
		this.forceUpdate();
	
	}

	hideParent(e, i){
		var parent = "";
		this.state.traceability.map((t, x)=>{
			if(i === 0){
				if(t.children === null){
					t.icon = true;
					t.show = true;
				}else{
					t.icon = false;
					t.show = false;
				}	
			}else{
				parent = this.state.traceability[i].children;
				this.state.traceability[i].icon = false;
				this.state.traceability[i].show = false;

				if(t.parent === parent){
					t.icon = true;
					t.show = true;
				}
			}
		})
		
		this.forceUpdate();
	}

	showStatus(e, status){
		this.modal_status.handleShow(status);
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.warehouse.MAIN')} ->
						Trazabilidad Unidades
					</h5>
				</div>

				<Help 
					{...this.props}
		            menu={"help_storage"} 
		            submenu={"help_simple_unit_traceability"}  />
		            
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<form noValidate>
						<div className="col-xs-12">
							<fieldset>
								<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-2">
										<label>No. Unidad</label>
										<input type="text" name="unit_number" id="unit_number" className="form-control" value={this.state.unit_number || ""} 
											onChange={this.handleChange} required onKeyPress={(e) => this.validateInput(e)} 
										/>
									</div>
									
									<div className="col-xs-12 col-sm-1"style={{paddingTop:"17px"}}>
					        			<button style={{fontSize:"1em"}} className="btn btn-info" 
					        				type="button" onClick={this.onSearch} >
					        				{t('content.generics.buttons.search')}
					        			</button>
									</div>
								</div>						
							</fieldset>	
						</div>

						<hr style={{width:"90%"}} />
						
						{!this.state.show_columns_pools ?
							<div className="col-xs-12 col-sm-4 form-group">
								<h4 style={{margin:'0'}}>COMPONENTES SANGUÍNEOS ENCONTRADOS</h4>
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-4">
										<label>No. Unidad</label>
									</div>
									<div className="col-xs-12 col-sm-8">
										<span className="color-font" >{this.state.unit_number_found}</span>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-4">
										<label>Fecha donación</label>
									</div>
									<div className="col-xs-12 col-sm-8">
										<span className="color-font" >{this.state.donation_date !== "" ? moment(this.state.donation_date).format('DD/MM/YYYY') : ""}</span>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-4">
										<label>Tipo bolsa</label>
									</div>
									<div className="col-xs-12 col-sm-8">
										<span className="color-font">{this.state.bag_type}</span>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-4">
										<label>Donante</label>
									</div>
									<div className="col-xs-12 col-sm-8">
										<span className="color-font">{this.state.donor}</span>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-4">
										<label>Lugar Colecta</label>
									</div>
									<div className="col-xs-12 col-sm-8">
										<span className="color-font">{this.state.convoke_place}</span>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-4">
										<label>Tipo donación</label>
									</div>
									<div className="col-xs-12 col-sm-8">
										<span className="color-font">{this.state.donation_type}</span>
									</div>
								</div>
								<div className="col-xs-12">
									<h2 style={{margin:'0',textAlign:'center',color:'red'}}>{this.state.group_rh}</h2>
								</div>
							</div>
						
						: <div className="col-xs-12 col-sm-8 form-group">
								<h4 style={{margin:'0'}}>COMPONENTES SANGUÍNEOS ENCONTRADOS</h4>
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-2">
										<label>Fecha de creación</label>
									</div>
									<div className="col-xs-12 col-sm-8">
										<span className="color-font" >{this.state.donation_date !== "" ? moment(this.state.donation_date).format('DD/MM/YYYY') : ""}</span>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-2">
										<label>
											{this.state.type === 'POOL' ? 
												"Unidades del Pool"
											: this.state.type === 'RECONSTITUTION' ?
												"Unidades de Reconstitución"
											: null}
										</label>
									</div>
									<div className="col-xs-12 col-sm-8">
										<span className="color-font">{this.state.units_pool}</span>
									</div>
								</div>
							</div>}
							

						<div>
							<Table resposive="true" hover>
								<thead>
									<tr>
										<th>Componente</th>
										<th></th>
										<th>No. Componente</th>
										<th>Volumen</th>
										<th>Ubicación</th>
										<th>Estatus</th>
										<th>F. Proceso</th>
										<th>F. Caducidad</th>										
									</tr>
								</thead>
								<tbody>
									{this.state.traceability.map((t, i)=>(
										t.show ?
											<tr key={i}>
												<td style={
													 !t.icon ?
														{paddingLeft:t.padding}
													: t.parent === null ? 
														{paddingLeft:t.padding}
													: {paddingLeft:'8px'}}>{t.component}</td>
												<td>
													
													{t.icon ?
														t.parent===null ?
															<SvgIcon style={{cursor:'pointer'}} icon={arrowDown} 
																onClick={(e)=>this.hideParent(e,i)} />
														:(t.parent !== null && t.children !== null)?  
															<SvgIcon style={{cursor:'pointer'}} icon={arrowUp} 
																onClick={(e)=>this.showParent(e,t.parent)} />
														:t.parent!==null && t.children === null ?
															<SvgIcon style={{cursor:'pointer'}} icon={arrowUp} 
																onClick={(e)=>this.showParent(e,t.parent)} />
														:null
													:null}
												
												</td>
												<td>{t.component_number}</td>
												<td>{t.volume+' ml'}</td>
												<td>{t.ubication}</td>
												<td>
													{t.hide_status ?
														<SvgIcon style={{cursor:'pointer', marginRight:'7px'}} icon={notification} 
															onClick={(e)=>this.showStatus(e, t.status)} />
													:null}
													{t.hide_status ?
														t.status !== null ? 
															t.status.length > 0 ? 
																t.status[t.status.length - 1].status
															: null
														:null
													:null}
												</td>
												<td>
													{t.process_date !== null && t.process_date !== "" ?
														moment(t.process_date).format('DD/MM/YYYY')+' '
													: ""}
													{t.process_hour !== null && t.process_hour !== "" ?
														moment(t.process_hour, 'H:mm:ss').format('HH:mm')
													:""}
												</td>
												<td>
													{moment(t.caducidad).format('DD/MM/YYYY HH:mm')}
												</td>
											</tr>
										: null
									))}
								</tbody>
							</Table>
							{/*this.json2html(this.state.distributionsList)*/}
						</div>
					</form>
				</div>
				
				<ModalStatus {...this.props} onRef={ref => this.modal_status = ref} />
			</div>
		)
	}
}

export default translate('translations')(UnitsTraceability);